import * as FC from "@fluentui/react-components";
import * as IC from "@fluentui/react-icons";
import { useCallback, useState } from "react";

export const useSearchInput = ({ placeholder } = {}) => {
    const [filter, setFilter] = useState(null);
    // Bumped by clearSearch. The input is uncontrolled — it reads `defaultValue` once — so the only
    // way to put the box back to empty is to remount it, and a changing key is what does that.
    // Deliberately NOT keyed on `filter`: remounting on every keystroke would take focus away
    // mid-word.
    const [resetToken, setResetToken] = useState(0);

    /**
     * @param {import("@fluentui/react-components").InputProps} props
     */
    const SearchInput = useCallback(
        (props) => (
            <FC.Input
                key={resetToken}
                contentBefore={<IC.SearchFilled />}
                placeholder={placeholder || "输入检索关键字..."}
                style={{ flex: 1 }}
                defaultValue={filter || ""}
                onChange={(_, data) => setFilter(data.value)}
                {...props}
            />
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [resetToken]
    );

    /**
     * Empties both the filter and the visible box.
     *
     * Exists so an empty result can offer a way out of it. A list filtered down to nothing looks
     * exactly like a list with nothing in it, and on 2026-08-13 that ambiguity was read as deleted
     * data; an empty state that names the search term is only useful if the operator can also
     * undo it.
     */
    const clearSearch = useCallback(() => {
        setFilter("");
        setResetToken((token) => token + 1);
    }, []);

    return {
        filter,
        SearchInput,
        clearSearch,
    };
};
